import { render, staticRenderFns } from "./indexTestDoubleVideo.vue?vue&type=template&id=3149597f&scoped=true"
import script from "./indexTestDoubleVideo.vue?vue&type=script&lang=js"
export * from "./indexTestDoubleVideo.vue?vue&type=script&lang=js"
import style0 from "./indexTestDoubleVideo.vue?vue&type=style&index=0&id=3149597f&prod&lang=less&scoped=true"
import style1 from "./indexTestDoubleVideo.vue?vue&type=style&index=1&id=3149597f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@6.10.0_vue-template-compiler@2.7.16_webpack@5.91.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3149597f",
  null
  
)

export default component.exports